export default "__VITE_ASSET__2950c158__"